import * as R from 'ramda'
import moment from 'moment'

const orderSchema = {
  type: 'Object',
  contents: {
    _id: { type: 'ObjectId' },
    status: {
      type: 'String',
      label: '狀態',
      options: ['新增', '確認訂購', '部份交貨', '完成', '取消'],
    },
    key: {
      type: 'String',
      label: '採購單號',
      counter: {
        key: () => `PR${moment().format('YYMMDD')}`,
        value: (key, value) => `${key}${value.toString().padStart(3, 0)}`,
      },
    },
    keyOfSellerSide: { type: 'String', label: '供應端單號' },
    date: { type: 'Date', label: '採購日期' },
    expectedArrivalDate: { type: 'Date', label: '預計到貨日期' },
    personInCharge: {
      type: 'ObjectId',
      label: '負責人',
      reference: 'staffers',
      refKeys: ['key'],
    },
    sellerRef: {
      type: 'ObjectId',
      label: '供應商',
      reference: 'suppliers',
      refKeys: ['key'],
    },
    seller: {
      type: 'Object',
      contents: {
        key: { type: 'String', label: '名稱' },
        contact: { type: 'String', label: '聯絡人' },
        phone: { type: 'String', label: '電話' },
        email: { type: 'String', label: 'Email' },
        fax: { type: 'String', label: '傳真' },
        address: { type: 'String', label: '地址' },
      },
    },
    amount: { type: 'Number', label: '總金額', format: '0[.]000' },
    summary: { type: 'String', label: '總數量' },
    pricebookRef: {
      type: 'ObjectId',
      label: '使用價格表',
      reference: 'pricebooks',
      refKeys: ['key'],
    },
    note: { type: 'String', label: '備註' },
  },
}

const itemSchema = {
  type: 'Object',
  contents: {
    _id: { type: 'ObjectId' },
    skuRef: {
      type: 'ObjectId',
      label: '品項',
      reference: 'skus',
      refKeys: ['key'],
    },
    sku: {
      type: 'Object',
      contents: {
        key: { type: 'String', label: '品項編號' },
        barcode: { type: 'String' },
      },
    },
    name: { type: 'String', label: '名稱' },
    qty: { type: 'Number', label: '數量' },
    price: { type: 'Number', label: '單價' },
    subtotal: { type: 'Number', label: '小計', format: '0[.]000' },
    note: { type: 'String', label: '項目備註' },
  },
}

export default R.assocPath(
  ['contents', 'items'],
  { type: 'Array', contents: [itemSchema] },
  orderSchema,
)
